<template>
  <div class="card resource-signup-box">
    <div class="card-content">
      <h5>Want to download this resource for free?</h5>
      <p>Get free access to all our resources just by signing up.</p>
      <Button size="medium" :to="{ name: 'login', params: (redirectTo ? { redirect: redirectTo } : {}) }">Join Fun Learning</Button>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button'

export default {
  components: {
    Button
  },

  props: {
    redirectTo: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="scss">

@import '~styles/base/variables';
@import '~styles/base/mixins';

.resource-signup-box {

  h5 {
    margin-bottom: .5rem;
    font-weight: 600;
    color: $color-text-dark;
  }

  p {
    margin-bottom: 1rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ResourceSignupBox.vue